package site.shadadman.pages.worklog.SportsGameX

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initJul32025SportsGamexFirebaseAnalyticsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/SportsGameX/jul32025SportsGamexFirebaseAnalytics.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/SportsGameX/jul32025-sports-gamex-firebase-analytics")
@Composable
fun Jul32025SportsGamexFirebaseAnalyticsPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("jul-3-2025-sportsgamex-firebase-analytics") }) {
        org.jetbrains.compose.web.dom.Text("jul-3-2025-SportsGamex-Firebase-Analytics")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We already had Firebase through the Google Sign‑In implementation, so adding a KMP module for Analytics wasn’t a challenge. We needed this badly, it was going to be a huge help for tracking user events, especially since we had many user stories in our Fantasy section.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I was at the finish line for this module, that I decided to create some proactiveness and have a strategic vision. My mission was only Firebase Analytics but what if we needed to use other analytics platforms like ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("MixPannel")
        }
        org.jetbrains.compose.web.dom.Text("? We need to develop another module for ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("MixPannel")
        }
        org.jetbrains.compose.web.dom.Text(" too? that's not a correct architecture.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("For that i found the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Observer Pattern")
        }
        org.jetbrains.compose.web.dom.Text(" an excellent choice for this purpose to decouple the event broadcasting. You can easily register any other platforms and this analytics system will submit the event to all of them. Receive and process the same event independently without the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("AnalyticsRegistry")
        }
        org.jetbrains.compose.web.dom.Text(" needing to know the specifics of each service.")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""data class AnalyticsEvent(val name: String, val params: Map<String, Any?> = mapOf())

interface AnalyticsService {
    fun logEvent(event: AnalyticsEvent)
}

object AnalyticsRegistry {
    private val services = mutableSetOf<AnalyticsService>()

    fun register(service: AnalyticsService) {
        services += service
    }

    fun unregister(service: AnalyticsService) {
        services -= service
    }

    fun logEvent(event: AnalyticsEvent) {
        services.forEach { it.logEvent(event) }
    }

    fun logEvent(name: String, buildParams: MutableMap<String, Any?>.() -> Unit = {}) {
        val params = mutableMapOf<String, Any?>().apply(buildParams)
        services.forEach { it.logEvent(AnalyticsEvent(name, params)) }
    }
}

""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Another task successfully completed! My colleagues were very impressed, and I’m very proud of myself.")
    }
}
